import React, { useState } from 'react';
import { Button, Tooltip } from '@mui/material';
import ConfirmDialog from '../../../shared/components/ConfirmDialog';

interface Props {
  publishing: boolean;
  disabled?: boolean;
  /** Why the button is disabled, shown on hover. */
  disabledReason?: string;
  onPublish: () => Promise<boolean>;
}

// Publishing cannot be taken back, so the button always asks first and says why.
const WorkflowPublishButton: React.FC<Props> = ({ publishing, disabled = false, disabledReason, onPublish }) => {
  const [confirming, setConfirming] = useState(false);

  return (
    <>
      <Tooltip title={disabled && disabledReason ? disabledReason : ''}>
        <span>
          <Button
            variant="outlined"
            color="success"
            onClick={() => setConfirming(true)}
            disabled={disabled || publishing}
          >
            {publishing ? 'Publishing...' : 'Publish'}
          </Button>
        </span>
      </Tooltip>
      <ConfirmDialog
        open={confirming}
        title="Publish this draft?"
        onCancel={() => setConfirming(false)}
        onConfirm={() => {
          setConfirming(false);
          void onPublish();
        }}
        confirmText="Publish"
        confirmColor="warning"
      >
        Publishing freezes the draft as the next version. That version becomes immutable: it can
        never be edited, only followed by a newer one. Runs can start on it straight away. The
        draft stays open for further editing.
      </ConfirmDialog>
    </>
  );
};

export default WorkflowPublishButton;
